import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  searchBar: {
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    padding: '2px 4px',
    margin: '2px',
    '& .MuiInputBase-input': {
      marginLeft: '-5px',
      color: '#2C2D3E',
      fontWeight: 400,
      width: '100%',
    },
  },
}));